import ClientsDataGrid from "./ClientsDataGrid";
import { FullPagePaperLayout } from "pages/Layouts/FullPagePaperLayout";
import { PageBreadcrumbs, PageSubtitle, PageTitle } from "pages/Layouts/components/PageTitleContainer";

export function Clients() {
  return (
    <FullPagePaperLayout>
      <PageBreadcrumbs links={[{ label: "Support" }]} />
      <PageTitle>Clients</PageTitle>
      <PageSubtitle>Impersonate a client user.</PageSubtitle>

      <ClientsDataGrid />
    </FullPagePaperLayout>
  );
}
